<template>
    <v-row>
        <v-card-text>
            <p class="body-1">{{ $t('oampublication/label--schuljobs-category-description') }}</p>
            <ValidationProvider
                v-slot="{ errors }"
                :name="$t('oampublication/label--schuljobs-category-1')"
                rules="required"
            >
                <v-select
                    v-model="schuljobsCategoryID1"
                    :items="cboValues"
                    clearable
                    item-text="text"
                    item-value="id"
                    :label="$t('oampublication/label--schuljobs-category-1')"
                    :error-messages="errors"
                    required
                ></v-select>
            </ValidationProvider>
            <v-select
                v-model="schuljobsCategoryID2"
                :items="cboValues"
                clearable
                item-text="text"
                item-value="id"
                :label="$t('oampublication/label--schuljobs-category-2')"
            ></v-select>
            <v-select
                v-model="schuljobsCategoryID3"
                :items="cboValues"
                clearable
                item-text="text"
                item-value="id"
                :label="$t('oampublication/label--schuljobs-category-3')"
            ></v-select>
        </v-card-text>
    </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { ValidationProvider } from 'vee-validate'

export default {
    components: {
        ValidationProvider,
    },
    data: () => ({
        connectorId: -17,
        loading: true,
        cboList: 'SchuljobsCategory',
    }),
    computed: {
        ...mapGetters('cbo', ['cboValues']),
        ...mapGetters('pub', ['getExtensionValueByKey']),
        schuljobsCategoryID1: {
            get: function () {
                return this.getExtensionValueByKey('SchuljobsCategoryID1')
            },
            set: function (val) {
                this.editExtension({ key: 'SchuljobsCategoryID1', value: val })
            },
        },
        schuljobsCategoryID2: {
            get: function () {
                return this.getExtensionValueByKey('SchuljobsCategoryID2')
            },
            set: function (val) {
                this.editExtension({ key: 'SchuljobsCategoryID2', value: val })
            },
        },
        schuljobsCategoryID3: {
            get: function () {
                return this.getExtensionValueByKey('SchuljobsCategoryID3')
            },
            set: function (val) {
                this.editExtension({ key: 'SchuljobsCategoryID3', value: val })
            },
        },
    },
    mounted() {
        this.getItems(this.cboList).then(() => {
            this.loading = false
            this.$emit('child-rendered')
        })
    },
    methods: {
        ...mapActions('cbo', ['getItems']),
        ...mapActions('pub', ['editExtension']),
    },
}
</script>

<style scoped></style>
